import { gql } from '@apollo/client';

export const CERTIFICATES_QUERY = gql`
  query certificateTemplates {
      certificateTemplates {
          edges {
              node {
                  id
                  name
                  createdAt
                  updatedAt
                  description
                  templateKey
                  certificateTemplateUrl
                  brand {
                      id
                      name
                  }
                  certificateProfile {
                      id
                      name
                      description
                  }
              }
          }
      }
  }
`;

export default CERTIFICATES_QUERY;
